import { Box } from '@chakra-ui/react'
import { FC } from 'react'

type ActiveIndicatorDotProps = {
  isActive: boolean
}

export const ActiveIndicatorDot: FC<ActiveIndicatorDotProps> = ({
  isActive,
}) => {
  return (
    <Box
      position="absolute"
      right="19px"
      top="calc(50% - 3px)"
      transform="translateX(50%)"
      w="6px"
      h="6px"
      opacity={isActive ? '1' : '0'}
      background="gradients.dark"
      borderRadius="999px"
      transition="opacity 0.5s ease-out;"
    />
  )
}
